"use client"

import { MessageSquare, Clock, CheckCircle, AlertCircle, TrendingUp, Users, FileText, Calendar } from "lucide-react"

export default function DashboardContent({ userType }) {
  // Mock data for dashboard
  const stats =
    userType === "citizen"
      ? [
        {
          title: "My Feedback",
          value: "12",
          change: "+2 this month",
          icon: MessageSquare,
          color: "bg-blue-500",
        },
        {
          title: "Pending",
          value: "3",
          change: "-1 from last week",
          icon: Clock,
          color: "bg-yellow-500",
        },
        {
          title: "Resolved",
          value: "8",
          change: "+3 this month",
          icon: CheckCircle,
          color: "bg-green-500",
        },
        {
          title: "In Progress",
          value: "1",
          change: "No change",
          icon: AlertCircle,
          color: "bg-orange-500",
        },
      ]
      : [
        {
          title: "Total Engagements",
          value: "1,234",
          change: "+12% from last month",
          icon: MessageSquare,
          color: "bg-blue-500",
        },
        {
          title: "Active Users",
          value: "856",
          change: "+5% from last week",
          icon: Users,
          color: "bg-green-500",
        },
        {
          title: "Pending Reviews",
          value: "43",
          change: "-8% from yesterday",
          icon: Clock,
          color: "bg-yellow-500",
        },
        {
          title: "Resolution Rate",
          value: "94%",
          change: "+2% improvement",
          icon: TrendingUp,
          color: "bg-purple-500",
        },
      ]

  const recentActivity =
    userType === "citizen"
      ? [
        {
          id: 1,
          title: "Feedback submitted for Road Maintenance",
          status: "pending",
          date: "2 hours ago",
          trackingId: "FB-2024-001",
        },
        {
          id: 2,
          title: "Water Supply Issue - Status Updated",
          status: "in-progress",
          date: "1 day ago",
          trackingId: "FB-2024-002",
        },
        {
          id: 3,
          title: "Street Light Repair - Resolved",
          status: "resolved",
          date: "3 days ago",
          trackingId: "FB-2024-003",
        },
      ]
      : [
        {
          id: 1,
          title: "New feedback assigned to Water Department",
          status: "assigned",
          date: "30 minutes ago",
          trackingId: "FB-2024-045",
        },
        {
          id: 2,
          title: "Road maintenance feedback resolved",
          status: "resolved",
          date: "2 hours ago",
          trackingId: "FB-2024-044",
        },
        {
          id: 3,
          title: "Citizen engagement updated by John Doe",
          status: "updated",
          date: "4 hours ago",
          trackingId: "FB-2024-043",
        },
      ]

  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "bg-yellow-100 text-yellow-800"
      case "in-progress":
        return "bg-blue-100 text-blue-800"
      case "resolved":
        return "bg-green-100 text-green-800"
      case "assigned":
        return "bg-purple-100 text-purple-800"
      case "updated":
        return "bg-gray-100 text-gray-800"
      default:
        return "bg-gray-100 text-gray-800"
    }
  }

  return (
    <div className="space-y-6">
      {/* Welcome Section */}
      <div className="bg-primary rounded-xl p-6 text-white">
        <h1 className="text-2xl font-bold mb-2">Welcome back!</h1>
        <p className="text-green-100">
          {userType === "citizen"
            ? "Track your feedback and stay updated on resolutions."
            : "Manage customer engagements and track resolution progress."}
        </p>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {stats.map((stat, index) => {
          const Icon = stat.icon
          return (
            <div key={index} className="bg-white rounded-xl p-6 shadow-sm border border-gray-200">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-gray-600">{stat.title}</p>
                  <p className="text-2xl font-bold text-gray-900 mt-1">{stat.value}</p>
                  <p className="text-sm text-gray-500 mt-1">{stat.change}</p>
                </div>
                <div className={`w-12 h-12 ${stat.color} rounded-lg flex items-center justify-center`}>
                  <Icon className="w-6 h-6 text-white" />
                </div>
              </div>
            </div>
          )
        })}
      </div>

      {/* Recent Activity */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-200">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-lg font-semibold text-gray-900">Recent Activity</h2>
            <button className="text-primary hover:text-primary/80 text-sm font-medium">View All</button>
          </div>
          <div className="space-y-4">
            {recentActivity.map((activity) => (
              <div key={activity.id} className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-primary rounded-full mt-2"></div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-gray-900">{activity.title}</p>
                  <div className="flex items-center space-x-2 mt-1">
                    <span
                      className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(activity.status)}`}
                    >
                      {activity.status.replace("-", " ")}
                    </span>
                    <span className="text-xs text-gray-500">{activity.trackingId}</span>
                  </div>
                  <p className="text-xs text-gray-500 mt-1">{activity.date}</p>
                </div>
              </div>
            ))}
          </div>
        </div> */}

        {/* Quick Actions */}
        <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-200">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">Quick Actions</h2>
          <div className="space-y-3">
            {userType === "citizen" ? (
              <>
                <button className="w-full flex items-center justify-between p-3 text-left border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
                  <div className="flex items-center">
                    <FileText className="w-5 h-5 text-primary mr-3" />
                    <span className="font-medium">Submit New Feedback</span>
                  </div>
                  <span className="text-gray-400">→</span>
                </button>
                <button className="w-full flex items-center justify-between p-3 text-left border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
                  <div className="flex items-center">
                    <MessageSquare className="w-5 h-5 text-primary mr-3" />
                    <span className="font-medium">Track Feedback</span>
                  </div>
                  <span className="text-gray-400">→</span>
                </button>
                <button className="w-full flex items-center justify-between p-3 text-left border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
                  <div className="flex items-center">
                    <Calendar className="w-5 h-5 text-primary mr-3" />
                    <span className="font-medium">Schedule Appointment</span>
                  </div>
                  <span className="text-gray-400">→</span>
                </button>
              </>
            ) : (
              <>
                <button className="w-full flex items-center justify-between p-3 text-left border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
                  <div className="flex items-center">
                    <MessageSquare className="w-5 h-5 text-primary mr-3" />
                    <span className="font-medium">Review Pending Engagements</span>
                  </div>
                  <span className="text-gray-400">→</span>
                </button>
                <button className="w-full flex items-center justify-between p-3 text-left border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
                  <div className="flex items-center">
                    <Users className="w-5 h-5 text-primary mr-3" />
                    <span className="font-medium">Assign to Team Member</span>
                  </div>
                  <span className="text-gray-400">→</span>
                </button>
                <button className="w-full flex items-center justify-between p-3 text-left border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
                  <div className="flex items-center">
                    <FileText className="w-5 h-5 text-primary mr-3" />
                    <span className="font-medium">Generate Report</span>
                  </div>
                  <span className="text-gray-400">→</span>
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
